<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Gerenciamento de Autenticações</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovaAutenticacao" />

    <SGPTabelaComponent
      v-if="listaDeAutenticacoes.length"
      :colunas="colunas"
      :dados="listaDeAutenticacoes"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Cadastro de Autenticação"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioAclAutenticacaoComponent
        :tipoFormulario="tipoFormulario"
        :autenticacao="autenticacao"
      />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingAutenticacoes"/>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioAclAutenticacaoComponent from '../components/FormularioAclAutenticacaoComponent.vue'

export default {
  components: { FormularioAclAutenticacaoComponent },
  name: 'AclAutenticacaoPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      autenticacoesSelecionadas: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      autenticacao: {}
    }
  },
  created () {
    this.listarAutenticacoes();
  },
  computed: {
    ...mapGetters('aclAutenticacoes', ['listaDeAutenticacoes', 'loadingAutenticacoes']),

    colunas () {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        },
        {
          key: 'autenticacao',
          label: 'Autenticação',
          sortable: false
        },
        {
          key: 'descricao',
          label: 'Descrição',
          sortable: false
        }
      ]
    }
  },

  methods: {
    ...mapActions('aclAutenticacoes', ['listarAutenticacoes','excluirAutenticacoes']),

    gerenciadorDeSelecionados (selecionados) {
      this.autenticacoesSelecionadas = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.autenticacao = this.autenticacoesSelecionadas[0];
      this.abrirModal = true;
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirAutenticacoes(this.autenticacoesSelecionadas);
      this.deletarDados = false;
    },

    adicionarNovaAutenticacao () {
      this.autenticacao = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    }

  }
}
</script>
